import Html from "../assets/html.svg";
import Css from "../assets/css.svg";
import JavaScript from "../assets/javascript.svg";
import Python from "../assets/python.svg";
import React from "../assets/react.svg";
import Django from "../assets/django.svg";

const skill_data = [
  {
    s_no: 1,
    s_name: "HTML",
    s_img: Html,
  },
  {
    s_no: 2,
    s_name: "CSS",
    s_img: Css,
  },
  {
    s_no: 3,
    s_name: "JavaScript",
    s_img: JavaScript,
  },
  {
    s_no: 4,
    s_name: "Python",
    s_img: Python,
  },
  {
    s_no: 5,
    s_name: "React.js",
    s_img: React,
  },
  {
    s_no: 6,
    s_name: "Django & DRF",
    s_img: Django,
  },
];

export default skill_data;
